var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chat-window',{attrs:{"current-user-id":_vm.currentUserId,"rooms":_vm.rooms,"messages":_vm.messages}})
}
var staticRenderFns = []

export { render, staticRenderFns }